export const environment = {
  production: true,

  // ✅ Versión app (PROD / APK)
  appVersion: '0.9.0',

  // 👇 flag mock (en prod normalmente desactivado)
  useMockAuth: false,

  // 👇 En producción NUNCA permitimos subir desde navegador
  allowWebUploadForDev: false,

  // ✅ Fase 2 (caminos) ON/OFF
  enablePhase2Paths: false,

  // 🔥 Firebase config (producción)
  firebase: {
    apiKey: "AIzaSyBsdQ_y_Ft9U0WaCtQucLASyJB_KbzWhtM",
    authDomain: "challup-67cdd.firebaseapp.com",
    projectId: "challup-67cdd",
    storageBucket: "challup-67cdd.firebasestorage.app",
    messagingSenderId: "463583860787",
    appId: "1:463583860787:web:c8c1450e626db53049eb46",
    measurementId: "G-ZY8P26ZEBF",

    // 👇 Clave pública Web Push (VAPID) para FCM en producción
    vapidKey:
      "BHjc5WgCSYlCelYL-PYTfJg6gKSUB-LRglFv1rv-dmLNopHHdvt6wBQhfckHtlspYSWyHLNMyT1hYZMJ2iHspeA",
  },

  // 🔑 Azure AD (prod real)
  clientId: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
  redirectUri: "https://tu-dominio.com",
  postLogoutRedirectUri: "https://tu-dominio.com",

  // 🌐 backend (prod real)
  backendUrl: "https://api.tu-dominio.com",

  // 📦 Azure Storage
  azureBlobBaseUrl: "https://tu-cuenta-azure.blob.core.windows.net",
  azureMediaPrefix: "media/"
};
